<script lang="ts">
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { real_id } from '../../../../helpers/interface_helpers';
	import { getErrorOrInfoMessageForMinAndMax } from '../../../../helpers/utilities';
	import { onSettingsResponse } from '../../../../helpers/device_settings_helpers';
	//Services
	import { postReq } from '../../../../services/http';
	//Stores
	//Design system components
	import { Text, Input, Button } from '@Shelly/shelly-design-system';
	//Types
	import type { SettingRequest } from '../../../../types/requests/settings/setting';
	import type { Device } from '../../../../types/Device';
	export let device: Device;

	const id = real_id(device.id),
		settings = readDeviceSettings(id),
		min = 0,
		max = 100000,
		save = async () => {
			waitForResponse = true;
			const res: SettingRequest = await postReq(
				`/device/generic_command`,
				{
					id,
					command: 'illumination_threshold',
					payload: JSON.stringify({
						dark_threshold: Number(dark),
						twilight_threshold: Number(dusk),
					}),
				},
				20000,
			);
			const toastTexts = {
				success: $format('illumination_set_scc_toast', {
					default: 'Illumination definitions set successfully.',
				}),
				danger: $format('illumination_set_err_toast', {
					default: 'Failed to set illumination definitions.',
				}),
			};
			onSettingsResponse(res, device, toastTexts);
			waitForResponse = false;
		};

	let dark = settings.dark_threshold,
		dusk = settings.twilight_threshold,
		waitForResponse = false;

	$: inputDataDark = getErrorOrInfoMessageForMinAndMax(dark, min, max);
	$: inputDataDusk = getErrorOrInfoMessageForMinAndMax(dusk, min, max);
</script>

<Text styleType="body-small" class="mb-xs">
	{$format('illumination_set_dark', { default: 'Set dark:' })}
</Text>

<Input
	size="m"
	class="mb-s"
	icon="fas fa-calculator"
	bind:value={dark}
	info={inputDataDark.info}
	error={inputDataDark.error}
	type="number"
	step={1}
	aria-label={$format('illumination_set_dark', { default: 'Set dark' })}
	id="input-lgk700m"
/>

<Text styleType="body-small" class="mb-xs">
	{$format('illumination_set_dusk', { default: 'Set dusk:' })}
</Text>

<Input
	size="m"
	class="mb-s"
	icon="fas fa-calculator"
	bind:value={dusk}
	info={inputDataDusk.info}
	error={inputDataDusk.error}
	type="number"
	step={1}
	aria-label={$format('illumination_set_dusk', { default: 'Set dusk' })}
	id="input-nv4xgs9"
/>

<Button
	size="m"
	width="full"
	loading={waitForResponse}
	disabled={inputDataDark.error || inputDataDusk.error}
	on:click={save}
>
	{$format('button_save', { default: 'Save' })}
</Button>
